import { FormParagraphFormGroup } from '@frontend/components/fields/FormParagraphField';

interface IGeneralSettingsReadOnlyFormGroupProps {
    label: string;
    value: string | null;
}

export function GeneralSettingsReadOnlyFormGroup(props: IGeneralSettingsReadOnlyFormGroupProps) {
    return <FormParagraphFormGroup label={props.label}>{props.value || '-'}</FormParagraphFormGroup>;
}
